export const CATEGORIES = "/indicator/category/";
export const SUB_CATEGORIES = "/indicator/category/:id/subcategory/";
export const VARIABLES = "/indicator/category/subcategory/:id/variable/";
export const INDICATORS =
  "/indicator/category/subcategory/variable/:id/resource/";
export const SEND_EMAIL = "/notification/contact/send-email/";
